enum GrupoOpmeTipoEnum {
  GrupoDoMedico = 'GrupoDoMedico',
  Protocolo = 'Protocolo',
  GrupoComNecessidadeDeAutorizacao = 'GrupoComNecessidadeDeAutorizacao',
  GrupoEmEstoque = 'GrupoEmEstoque',
}

export default GrupoOpmeTipoEnum
